/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import ProductGrid from './components/ProductGrid';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productGridNodes = Array.from(document.querySelectorAll('.product-grid'));
[...productGridNodes].forEach((node) => render(<ProductGrid {...parseDataToProps(node.dataset)} />, node));
